import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import CustomersPaymentHistory from '../../components/CustomersPaymentHistory';
import CustomersTable from '../../components/CustomersTable';
import CustomersView from '../../components/CustomersView';
import useActions from '../../hooks/useActions';

const Customers = ({ match }) => {
  const { setCustomerView } = useActions();

  useEffect(() => {
    return () => {
      setCustomerView('retailers');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="w-100 h-100">
      <Switch>
        <Route
          path={match.url}
          exact
          render={(props) => {
            return <CustomersTable {...props} />;
          }}
        />
        <Route
          path={`${match.url}/:id`}
          exact
          render={(props) => {
            return <CustomersView {...props} />;
          }}
        />
        <Route
          path={`${match.url}/statement/:customer_id/:first/:last`}
          exact
          render={(props) => {
            return <CustomersPaymentHistory {...props} />;
          }}
        />
      </Switch>
    </div>
  );
};

export default Customers;
